import axios from "axios";
import Config from "../utils/Config";
import helpers from "../utils/Helpers";

class PurchaseService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("trp_tk")}`,
      },
    };
  }

  async getPurchases() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/provider/policy/get/all/purchased`,
        {
          ...this.getAuthHeaders(),
        }
      );
      return {
        status: true,
        message: response.data.data?.reason || "Purchases fetched successfully",
        data: response.data.data,
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          "An error occurred while fetching purchases",
        data: null,
      };
    }
  }

  async getStatistics(filters = {}) {
    try {
      const {
        customerType = "all",
        status = "all",
        startDate = null,
        endDate = null,
        insurancePlan = "all",
      } = filters;

      const params = {};

      // Add optional filters
      if (customerType !== "all") params.customerType = customerType;
      if (status !== "all") params.status = status;
      if (insurancePlan !== "all") params.insurancePlan = insurancePlan;
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      const response = await axios.get(
        `${Config.apiUrl}/provider/purchases/statistics`,
        {
          ...this.getAuthHeaders(),
          params,
        }
      );
      return helpers.handleApiSuccess(
        response,
        "Statistics fetched successfully"
      );
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while fetching statistics"
      );
    }
  }

  /**
   * Get single purchase details
   * @param {string} purchaseId - Purchase ID
   * @returns {Promise<Object>} API response
   */
  async getPurchase(purchaseId) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/provider/purchases/${purchaseId}`,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(
        response,
        "Purchase fetched successfully"
      );
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while fetching purchase"
      );
    }
  }

  async cancelPurchase(policySlug) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/provider/confirm_cancel/purchased_policy/${policySlug}`,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(
        response,
        "Purchase cancelled successfully"
      );
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while cancelling purchase"
      );
    }
  }

  async revertCancellation(policySlug) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/provider/revert_cancel/purchased_policy/${policySlug}`,
        this.getAuthHeaders()
      );
      return helpers.handleApiSuccess(
        response,
        "Cancellation reverted successfully"
      );
    } catch (error) {
      return helpers.handleApiError(
        error,
        "An error occurred while reverting cancellation"
      );
    }
  }
}

const purchaseService = new PurchaseService();
export default purchaseService;
